import type { AdministrativeAreaType, AreaSummary, Locale } from './types'

export const transportContent = {
  ar: {
    dir: 'rtl' as const,
    languageLabel: 'EN',
    brand: 'Syria Bus Transport',
    brandSubtitle: 'نقل الباصات',
    labels: {
      filterMap: 'تصفية الخريطة',
      showFilters: 'إظهار الفلاتر',
      hideFilters: 'إخفاء الفلاتر',
      loading: 'جاري التحميل...',
      updatingMap: 'جاري تحديث الخريطة...',
      loadError: 'تعذر تحميل البيانات حالياً.',
      areasUnavailable: 'تعذر تحميل المناطق.',
      networksUnavailable: 'تعذر تحميل الشبكات.',
      noNetworks: 'لا توجد شبكات ضمن النطاق المختار',
      area: 'المنطقة',
      network: 'شبكة النقل',
      allAreas: 'كل المناطق',
      allGovernorates: 'كل المحافظات',
      allNetworks: 'كل الشبكات',
      clearFilters: 'مسح الفلاتر',
      mapUnavailable: 'الخريطة غير متاحة حالياً.',
      outbound: 'ذهاب',
      inbound: 'عودة',
      sharedRoute: 'ذهاب وعودة — نفس المسار',
      direction: 'اتجاه',
    },
  },
  en: {
    dir: 'ltr' as const,
    languageLabel: 'العربية',
    brand: 'Syria Bus Transport',
    brandSubtitle: 'Bus Transport',
    labels: {
      filterMap: 'Filter map',
      showFilters: 'Show filters',
      hideFilters: 'Hide filters',
      loading: 'Loading...',
      updatingMap: 'Updating map...',
      loadError: 'The data could not be loaded.',
      areasUnavailable: 'Areas could not be loaded.',
      networksUnavailable: 'Networks could not be loaded.',
      noNetworks: 'No networks in the selected scope',
      area: 'Area',
      network: 'Transport network',
      allAreas: 'All areas',
      allGovernorates: 'All governorates',
      allNetworks: 'All networks',
      clearFilters: 'Clear filters',
      mapUnavailable: 'The map is currently unavailable.',
      outbound: 'Outbound',
      inbound: 'Inbound',
      sharedRoute: 'Both directions — same route',
      direction: 'Direction',
    },
  },
} as const

export function contentFor(locale: Locale) {
  return transportContent[locale]
}

export function localizedName(
  value: { nameAr: string | null; nameEn: string | null },
  locale: Locale,
) {
  return locale === 'en'
    ? value.nameEn || value.nameAr || ''
    : value.nameAr || value.nameEn || ''
}

const areaTypeLabels: Record<Locale, Record<AdministrativeAreaType, string>> = {
  ar: {
    Country: 'دولة',
    Governorate: 'المحافظة',
    District: 'المنطقة',
    SubDistrict: 'ناحية',
    City: 'مدينة',
    Neighborhood: 'حي',
    Other: 'منطقة',
  },
  en: {
    Country: 'Country',
    Governorate: 'Governorate',
    District: 'District',
    SubDistrict: 'Sub-district',
    City: 'City',
    Neighborhood: 'Neighborhood',
    Other: 'Area',
  },
}

export function areaTypeLabel(type: AdministrativeAreaType, locale: Locale) {
  return areaTypeLabels[locale][type]
}

export function areaScopeLabel(area: AreaSummary | null, locale: Locale) {
  if (!area) return contentFor(locale).labels.allAreas

  const name = localizedName(area, locale) || area.code
  if (locale === 'ar') {
    if (area.type === 'Country') return `كل ما ضمن ${name}`

    const scopeType = areaTypeLabel(area.type, locale).replace(/^ال/, '')
    return `كل ما ضمن ${scopeType} ${name}`
  }

  if (area.type === 'Country') return `All within ${name}`
  return `All within ${name} ${areaTypeLabel(area.type, locale)}`
}
